import FeedSidebarContentPostsSidebar from './FeedSidebarContent';
import FeedSidebarContentContainer from './FeedSidebarContent.container';

export default FeedSidebarContentContainer(FeedSidebarContentPostsSidebar);
